module.exports = function() {
  return new Worker(__webpack_public_path__ + "14edab2601c5883883fa.worker.js");
};